import { RoleNames, Actor } from 'core';

export function isSystemAdmin(actor: Actor | null): boolean {
  return !!actor && RoleNames.sysAdmin === actor.roleName;
}

export function isBeaconAdmin(actor: Actor | null): boolean {
  return !!actor && RoleNames.beaconAdmin === actor.roleName;
}

export function isBeaconExcecutive(actor: Actor | null): boolean {
  return !!actor && RoleNames.beaconExecutive === actor.roleName;
}
